import $ from 'jquery'
import MatchHeight from './match_height'
import { products } from './_products'

export default class Survey {
  constructor() {
    this.query = [
      {
        id: 'q1',
        question: 'ここ数年で「ハリ・コシ減」「ボリューム減」「髪がやせた」<br>などの変化を感じることは？',
        answer: ['特に感じない', '感じる'],
        routes: ['q2', 'q3-2']
      },
      {
        id: 'q2',
        question: '毛先の枝毛や切れ毛の量は？',
        answer: ['それほどない', 'かなりある'],
        routes: ['q3-1', 'q3-1']
      },
      {
        id: 'q3-1',
        question: '地肌をチェック！色味はどう？',
        answer: ['青白く透明感がある', '赤みや黄みを帯びている'],
        routes: ['q4-1', 'q4-1']
      },
      {
        id: 'q3-2',
        question: '地肌をチェック！色味はどう？',
        answer: ['青白く透明感がある', '赤みや黄みを帯びている'],
        routes: ['q4-2', 'q4-2']
      },
      {
        id: 'q4-1',
        question: 'あなたがなりたい髪は？',
        answer: ['パサつきやすい髪をしっとりまとめたい', '絡まりやすい髪をさらさらにしたい', '崩れやすい髪型をスタイルキープしたい'],
        routes: ['q5-1', 'q6-1', 'q5-1']
      },
      {
        id: 'q4-2',
        question: '髪の毛にふんわりボリューム感を出したい？',
        answer: ['はい', 'いいえ'],
        routes: ['q6-1', 'q6-1']
      },
      {
        id: 'q5-1',
        question: 'ワンランク上の<br class="_d-md-none">プレミアムなケアをしたい？',
        answer: ['はい', 'いいえ'],
        routes: ['q6-1', 'q6-1']
      },
      {
        id: 'q6-1',
        question: '日中は、「冷暖房の効いた部屋」<br class="_d-md-none">または<br>「屋外」に長くいることが多い？',
        answer: ['多い', 'そうでもない'],
        routes: ['q7', 'q7']
      },
      {
        id: 'q7',
        question: '白髪が気になる。<br class="_d-md-none">または白髪染めをしている。',
        answer: ['気になる、または、している', '特に気にならないし、<br>白髪染めはしていない']
      }
    ]
    this.result = {
      q1: {
        a: {
          recommends: [{ id: 'sku01' }, { id: 'sku02' }],
          advice: 'あなたの髪はダメージが気になる状態です。<br class="_d-sm-none"/>日常生活で、髪へのダメージは積み重なっていきます。<br class="_d-sm-none"/>まずは毎日のシャンプーとトリートメントを<br class="_d-sm-none"/><span class="pink">ダメージケアタイプ</span>に切り替えましょう。'
        },
        b: {
          recommends: [{ id: 'sku20' }, { id: 'sku21' }],
          advice: 'あなたの髪は年齢による変化が気になる状態です。<br/>まずは毎日のシャンプーとトリートメントを<span class="pink">エイジングケアタイプ</span>に<br class="_d-sm-none"/>切り替えましょう。'
        }
      },
      q2: {
        a: {
          recommends: null,
          advice: null
        },
        b: {
          recommends: [{ id: 'sku03' }],
          advice: 'また、ダメージが深刻なので、<span class="pink">ヘアマスクでのスペシャルケア</span>を<br class="_d-sm-none"/>プラスするのがおすすめです。'
        }
      },
      'q3-1': {
        a: {
          recommends: null,
          advice: null
        },
        b: {
          recommends: [{ id: 'sku15' }, { id: 'sku16' }],
          advice: 'すこやかな髪を育てるために、<span class="pink">薬用 地肌 ジェル、薬用 地肌 ローション</span>での<br class="_d-sm-none"/>スカルプケアも取り入れるといいでしょう。'
        }
      },
      'q3-2': {
        a: {
          recommends: null,
          advice: null
        },
        b: {
          recommends: [{ id: 'sku15' }, { id: 'sku16' }],
          advice: 'すこやかな髪を育てるために、<span class="pink">薬用 地肌 ジェル、薬用 地肌 ローション</span>での<br class="_d-sm-none"/>スカルプケアも取り入れるといいでしょう。'
        }
      },
      'q4-1': {
        a: {
          recommends: [{ id: 'sku04' }],
          advice: 'さらに、まとまり感をアップする<span class="pink">しっとりタイプのヘアエッセンス</span>は必ずプラス。'
        },
        b: {
          recommends: [{ id: 'sku05' }],
          advice: 'さらに、まとまり感をアップする<span class="pink">さらさらタイプのヘアエッセンス</span>は必ずプラス。'
        },
        c: {
          recommends: [{ id: 'sku06' }],
          advice: 'ヘアスタイルをキープしたい人は<span class="pink">ヒートメモリーのヘアエッセンス</span>がおすすめ。'
        }
      },
      'q4-2': {
        a: {
          recommends: [{ id: 'sku10' }],
          advice: 'さらに、<span class="pink">ふんわりボリューム感を与えるヘアエッセンス</span>は必ずプラス。'
        },
        b: {
          recommends: [{ id: 'sku05' }],
          advice: 'さらに、まとまり感をアップする<span class="pink">さらさらタイプのヘアエッセンス</span>は必ずプラス。'
        }
      },
      'q5-1': {
        a: {
          recommends: [{ id: 'sku12' }, { id: 'sku13' }, { id: 'sku14' }],
          advice:
            'ワンランク上のケアをご希望のあなたには、<br class="_d-sm-none"/><span class="pink">プレミオール</span>シリーズの<span class="pink">シャンプー</span>と<span class="pink">トリートメント</span>をおすすめします。<br class="_d-sm-none"/>さらに、まとまり感をアップする<span class="pink">プレミオール ヘアエッセンス</span>をあわせてラインで使いましょう。'
        },
        b: {
          recommends: null,
          advice: null
        }
      },
      'q6-1': {
        a: {
          recommends: [{ id: 'sku07' }, { id: 'sku08' }, { id: 'sku09' }],
          advice: '<span class="pink">海藻シルキーヘアスプレー、ヘアミスト、ヘアミルク</span>を使って<br class="_d-sm-none"/>日中の乾燥や紫外線から髪を守ります。'
        },
        b: {
          recommends: null,
          advice: null
        }
      },

      q7: {
        a: {
          recommends: [{ id: 'sku17' }, { id: 'sku19' }],
          advice: '気になる白髪には、<span class="pink">髪にダメージを与えにくいヘアカラー</span>を使いましょう。'
        },
        b: {
          recommends: null,
          advice: null
        }
      }
    }
    this.element = $('.js-box-check')
    this.boxStart = this.element.find('.box-start')
    this.boxSurvey = this.element.find('.box-survey')
    this.boxResult = this.element.find('.box-result')

    this.answer = []
    this.noOfQuestion = 7
    this.state = 0
    this.page = 0
    this.flg_pre = false
    this.matchHeight = new MatchHeight({ target: '.js-matchHeight-group' })
    this.history = []
  }

  initial() {
    this.history.push({
      prev: null,
      current: this.currentQuestion.id,
      page: this.page
    })

    this.initStart()
    this.handelOnBack()
    this.createHtmlRoute(this.currentQuestion.id)
  }

  initStart() {
    this.boxStart.find('.js-start-survey').on('click', e => {
      e.preventDefault()
      this.boxStart.fadeOut(100)
      this.boxSurvey.fadeIn(1000).css('display', 'flex')
      this.progress(this.page, this.noOfQuestion)
    })
  }

  // progress bar
  progress(page = 0, max = 7) {
    const $progress = this.boxSurvey.find('.progress')
    $progress.find('.bar').css('width', `${(page / max) * 100}%`)
    $progress.find('.text .active').text(`00${page}`.slice(-2))
    $progress.find('.text .total').text(`00${max}`.slice(-2))
  }

  createHtmlRoute(id) {
    const data = this.query.find(v => v.id === id)
    const imgPath = id === 'q4-1' ? id : id === 'q4-2' ? id : id === 'q6-1' ? id : id === 'q6-2' ? id : id.slice(0, 2)

    this.boxSurvey
      .removeClass((idx, className) => {
        return className
          .split(' ')
          .filter(v => v.match(/q\d+/g))
          .join(' ')
      })
      .addClass(id.slice(0, 2))
      .addClass(id)
    this.boxSurvey.find('.question').html(data.question)
    this.boxSurvey.find('.box-check .list-choice').html(this.listRadio(id, data.answer))

    if (!id.match(/q3/)) {
      this.boxSurvey.find('.box-check figure img').attr('src', `/assets/image/check/img_check_${imgPath}.png`)
    }
    this.handleOnCheck()
  }

  get currentQuestion() {
    return this.query[this.state]
  }

  /**
   * * event
   */
  handleOnCheck() {
    const $radioBox = this.boxSurvey.find('.list-choice').children()
    $radioBox.each((idx, item) => {
      $(item).on('click', e => {
        if ($(e.currentTarget).find('input').is(':checked')) {
          const ans = idx === 0 ? 'a' : idx === 1 ? 'b' : 'c'
          // answer
          this.answer.push({
            ques: this.currentQuestion.id,
            ans
          })
          // condition
          const prevNoOfQuestion = this.noOfQuestion
          if (`${this.currentQuestion.id}${ans}` === 'q1b') {
            this.noOfQuestion = 6
          }
          if (`${this.currentQuestion.id}${ans}` === 'q4-1b') {
            this.noOfQuestion = 6
          }
          if (`${this.currentQuestion.id}${ans}` === 'q4-2b') {
            this.noOfQuestion = 5
          }
          if (`${this.currentQuestion.id}${ans}` === 'q4-2a') {
            this.noOfQuestion = 5
          }
          if (`${this.currentQuestion.id}${ans}` === 'q5-1a') {
            this.flg_pre = true
          }

          // next
          this.progress(++this.page, this.noOfQuestion)

          // end
          if (this.page === this.noOfQuestion) {
            this.history.push({
              prev: null,
              current: 'result'
            })
            this.showResult()
            return
          }

          this.history.push({
            prev: this.currentQuestion,
            current: this.currentQuestion.routes[idx],
            page: this.page,
            noOfQuestion: {
              prev: prevNoOfQuestion,
              now: this.noOfQuestion
            }
          })

          setTimeout(() => {
            this.boxSurvey.css({ opacity: '0' }).stop().animate({ opacity: 1 }, 1800, 'swing')
            this.createHtmlRoute(this.currentQuestion.routes[idx])
            this.state = this.query.findIndex(v => v.id === this.currentQuestion.routes[idx])
          }, 400)
        }
      })
    })
  }

  handelOnBack() {
    const $btnBack = this.element.find('.js-back')
    $btnBack.on('click', e => {
      e.preventDefault()
      const pageBefore = this.history.pop()
      if (pageBefore.prev === null) {
        if (pageBefore.current === 'result') {
          window.location.href = window.location.pathname
        }
        this.boxSurvey.fadeOut(0)
        this.boxStart.fadeIn(800)
        this.history = [{ prev: null }]
        this.answer = []
        this.createHtmlRoute(this.query[0].id)
      } else {
        this.answer.pop()
        this.boxSurvey.fadeOut(200).fadeIn(200)
        this.state = this.query.findIndex(i => i.id === pageBefore.prev.id)
        this.createHtmlRoute(pageBefore.prev.id)
        this.noOfQuestion = pageBefore.noOfQuestion.prev
        this.page = Math.max(pageBefore.page - 1, 0)
        this.progress(this.page, this.noOfQuestion)
      }
    })
  }

  /**
   * * Show result page
   */
  showResult() {
    setTimeout(() => {
      this.boxSurvey.stop().fadeOut(100)
      this.boxResult.fadeIn(800)

      let productRow = []
      let adviceRow = []
      const ignoreQ5 = [
        {
          ques: 'q1',
          ans: 'a'
        },
        {
          ques: 'q4-1',
          ans: 'a'
        }
      ]
      this.answer.forEach(v => {
        if (this.flg_pre) {
          if (ignoreQ5.map(d => d.ques !== v.ques).reduce((r, i) => r === i)) {
            productRow.push(this.result[v.ques][v.ans].recommends)
          }
        } else {
          productRow.push(this.result[v.ques][v.ans].recommends)
        }
        adviceRow.push({
          ques: v.ques,
          ad: this.result[v.ques][v.ans].advice
        })
      })

      if (this.flg_pre) {
        adviceRow.splice(
          adviceRow.findIndex(i => i.ques === 'q4-1'),
          1
        )
        adviceRow.splice(
          1,
          0,
          adviceRow.splice(
            adviceRow.findIndex(i => i.ques === 'q5-1'),
            1
          )
        )
      }

      const product = productRow
        .filter(v => v != null)
        .flat()
        .map(item => products.find(p => p.id === item.id))

      const advice = adviceRow
        .flat()
        .filter(x => x.ad != null)
        .map(x => x.ad)
        .join('<br>')

      this.boxResult.find('.text-advice').html(advice)
      this.boxResult.find('.p-list-products').html(this.listProduct(product))
      this.matchHeight.init()
    }, 400)
  }

  /**
   * * create html .list-choice
   */

  listRadio(id, list) {
    return list
      .map((v, i) => {
        return `
        <li class="item">
          <label class="p-check-radio-box">
            <input type="radio" name="radio"><span>${v}</span>
            ${id.match(/q3/) ? `<img src="/assets/image/check/img_check_q3-${i + 1}.png"/>` : ''}
          </label>
        </li>`
      })
      .join('')
  }
  /**
   * * create html .list-products
   */
  listProduct(products) {
    return products
      .map(li => {
        return `
        <li class="item">
          <a class="link" href="${li.link}">
            <div class="js-matchHeight-target-two">
              <figure class="image">
                <img src="${li.img}" alt="${li.name}">
              </figure>
            </div>
            <div class="box-title js-matchHeight-target-three">
              <span class="title">${li.name}</span>
              ${li.label != '' ? `<span class="label">${li.label}</span>` : ''}
            </div>
            <p class="text">${li.caption}</p>
          </a>
        </li>`
      })
      .join('')
  }
}
